import { useEffect, useState } from 'react';

export function useViewerCountry(): string | undefined {
  const [country, setCountry] = useState<string | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    fetch('/geo', { credentials: 'same-origin' })
      .then(async (res) => {
        if (!res.ok) return;
        const data = (await res.json()) as { country?: unknown };
        if (
          typeof data.country === 'string' &&
          /^[A-Z]{2}$/.test(data.country) &&
          data.country !== 'XX'
        ) {
          if (!cancelled) setCountry(data.country);
        }
      })
      .catch((err: unknown) => {
        console.warn('[exis] failed to load viewer country', err);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return country;
}
